import { Routes } from '@angular/router';
import { INDRASiteIsDownComponent } from '@ibe.components/is-down/site-is-down/site-is-down.indra.component';
import { INDRABookingGuardService } from '@ibe.services/booking-guard.indra.service';
// import { CorpRootService } from '@ibe.services/corp-root.service';
import { ExamplesComponent } from '@ibe.services/mocks.tap/examples/examples.component';
var ɵ0 = { title: 'Be right back' }, ɵ1 = { title: 'TAP Air Portugal' }, ɵ2 = { title: 'My Bookings' }, ɵ3 = { title: 'Check-in' }, ɵ4 = { title: 'Styleguide' }, ɵ5 = { title: 'Translation toggle' };
var appRoutes = [
    {
        path: 'notavailable',
        component: INDRASiteIsDownComponent,
        data: ɵ0
    },
    {
        path: 'booking',
        loadChildren: './components/booking/booking.module#BookingModule',
        data: ɵ1,
        canActivate: [INDRABookingGuardService /*, CorpRootService*/],
        canActivateChild: [INDRABookingGuardService]
    },
    {
        path: 'my-bookings',
        loadChildren: './components/myb/myb.module#MybModule',
        data: ɵ2,
        canActivate: [INDRABookingGuardService]
    },
    {
        path: 'check-in',
        loadChildren: './components/check-in/check-in.module#CheckInModule',
        data: ɵ3,
        canActivate: [INDRABookingGuardService]
    },
    /*
    }
        path: 'refunds',
        loadChildren: './components/refunds/refunds.module#RefundsModule',
        data: { title: 'Refunds' }
    },
    */
    /*
    {
        path: 'corporate',
        loadChildren: './components/corporate/corporate.module#CorporateModule',
        data: { title: 'Corporate' }
    },
    */
    {
        path: 'styleguide',
        loadChildren: './components/styleguide/styleguide.module#StyleguideModule',
        data: ɵ4
    },
    {
        path: 'trans',
        loadChildren: './components/translation-toggle/translation-toggle.module#TranslationToggleModule',
        data: ɵ5
    },
    { path: 'examples', component: ExamplesComponent },
    { path: '', /*canActivate: [CorpRootService],*/ redirectTo: '/booking', pathMatch: 'full' }
    // { path: '', redirectTo: '/booking', pathMatch: 'full' },
    // { path: '**', component: TAPPageNotFoundComponent, loadChildren: './components/booking/booking.module#BookingModule', data: { title: 'Page not found' } }
    // {
    // 	path: 'not-found',
    // 	loadChildren: './components/not-found/not-found.module#TAPNotFoundModule'
    // },
    // {
    // 	path: '**',
    // 	redirectTo: 'not-found',
    // 	pathMatch: 'full'
    // }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
